import { call, put, select, takeLatest } from 'redux-saga/effects'

import { selectAuthData } from '@/containers/Login/AuthSelectors'
import { callApi } from '@/shared/tools/apiSagaHelper'
import { showSnackbar, SNACKBAR_TYPES } from '@/shared/tools/notifications/notification'

import {
  fetchListRequest,
  fetchListSuccess,
  fetchListFailure,
  executeRequest,
  executeSuccess,
  executeFailure,
} from './commandsSlice'

export const commandsActions = {
  FETCH_LIST: 'DEVTOOLS_NEW/COMMANDS/FETCH_LIST',
  EXECUTE: 'DEVTOOLS_NEW/COMMANDS/EXECUTE',
}

function* fetchCommandsListSaga({ t }) {
  yield put(fetchListRequest())

  try {
    const { extraRoutes } = yield select(selectAuthData)
    const url = extraRoutes?.devTools?.commands?.list
    if (!url) {
      const message = t?.('commands.errors.missing_list_url') || 'Missing commands list url'
      yield put(fetchListFailure(message))
      return
    }

    const result = yield call(callApi, {
      endpoint: url,
      method: 'GET',
      showErrorSnackbar: false,
    })

    yield put(fetchListSuccess(result || []))
  } catch (error) {
    const message = error?.message || 'Error fetching commands list'
    yield put(fetchListFailure(message))
  }
}

export function* executeCommandSaga({ enqueue, t, payload }) {
  yield put(executeRequest())

  try {
    const { extraRoutes } = yield select(selectAuthData)
    const url = extraRoutes?.devTools?.commands?.execute
    if (!url) {
      const message = t?.('commands.errors.missing_execute_url') || 'Missing commands execute url'
      yield put(executeFailure({ error: message }))
      if (enqueue) yield call(showSnackbar, enqueue, { type: SNACKBAR_TYPES.ERROR, message })
      return
    }

    const command = payload?.command
    const result = yield call(callApi, {
      endpoint: url,
      method: 'GET',
      queryParams: { command },
      showErrorSnackbar: false,
    })

    if (result?.status === false) {
      const message = result?.response || t?.('commands.errors.execute_failed') || 'Command failed'
      yield put(executeFailure({ error: message, output: result?.output }))
      if (enqueue) yield call(showSnackbar, enqueue, { type: SNACKBAR_TYPES.ERROR, message })
      return
    }

    yield put(executeSuccess({ output: result?.output }))

    if (enqueue) {
      const message = t?.('commands.success') || 'Command executed'
      yield call(showSnackbar, enqueue, { type: SNACKBAR_TYPES.SUCCESS, message })
    }
  } catch (error) {
    const message = error?.message || 'Unknown error'
    yield put(executeFailure({ error: message }))
    if (enqueue) {
      yield call(showSnackbar, enqueue, { type: SNACKBAR_TYPES.ERROR, message })
    }
  }
}

export default function* commandsSagas() {
  yield takeLatest(commandsActions.FETCH_LIST, fetchCommandsListSaga)
  yield takeLatest(commandsActions.EXECUTE, executeCommandSaga)
}
